import React, { Fragment } from 'react';

import UseMemberClubTransferApproval from './UseMemberClubTransferApproval';

import MemberClubTransferApprovalForm from '../components/forms/memberClubTransferApprovalForm/MemberClubTransferApprovalForm';

import WorkFlowNavigation from '../components/navigation/WorkFlowNavigation';
import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';
import Textarea from '@usas/ui-web/components/inputs/Textarea';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const MemberClubTransferApproval = () => {
  const {
    location,
    Constants,
    isSaving,
    isLoading,
    personClubTransferState,
    formState,
    errorState,
    attachDateState,
    onLastCompetitionDateChanged,
    onBackClicked,
    onRejectClicked,
    onApprovedClicked,
    onFromValueChanged,
    onRejectModalCancelClicked,
    onRejectModalConfirmClicked
  } = UseMemberClubTransferApproval();

  return (
    <div className="row">
      <WorkFlowNavigation headerTitle={"Club Transfer Request" + `${location.state?.isRevisit === true ? ' - Revisit' : ' - New Request'}`}>
        <form noValidate>
          <MemberClubTransferApprovalForm
            transferObj={personClubTransferState.objData}
            isRevisit={location.state?.isRevisit}
            attachDateState={attachDateState}
            formState={formState}
            errorState={errorState}
            onLastCompetitionDateChanged={onLastCompetitionDateChanged} />
          {errorState.errorOnSubmitAction &&
            <div className="row">
              <div className="col-xs-12">
                <p className={global.ErrorMessage}>{errorState.errorOnSubmitAction || ''}</p>
              </div>
            </div>}
          <div className="row usas-extra-top-margin usas-extra-bottom-margin">
            <div className="col-xs-12">
              {location.state?.isRevisit === false && <Fragment><PrimaryButton type="button" onClick={onApprovedClicked}>Approve</PrimaryButton>&nbsp;</Fragment>}
              <SecondaryButton type="button" onClick={onBackClicked}>Back</SecondaryButton>&nbsp;
              {location.state?.isRevisit === false && <Fragment><PrimaryButton type="button" onClick={onRejectClicked}>Reject</PrimaryButton></Fragment>}
            </div>
          </div>
        </form>
      </WorkFlowNavigation>
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.LOADING_MSG}
        displayPopUp={isLoading} />
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.SAVING_MSG}
        displayPopUp={isSaving} />
      <PopUpModal
        widthPct={500}
        maxWidth={800}
        title="Reject Club Transfer"
        onModalCanceled={onRejectModalCancelClicked}
        displayPopUp={formState.isRejected}>
        <Fragment>
          <div className="row">
            <div className="col-xs-12">
              <Textarea
                className={global.Textarea}
                label="Reject Reason"
                name="stepNotes"
                value={formState.stepNotes}
                error={errorState.stepNotes}
                message={errorState.stepNotes}
                onChange={(value) => { onFromValueChanged('stepNotes', value); }} />
            </div>
          </div>
          <div className="row usas-extra-top-margin">
            <div className="col-xs-12">
              <PrimaryButton type="button" onClick={onRejectModalConfirmClicked}>Confirm</PrimaryButton>&nbsp;
              <SecondaryButton type="button" onClick={onRejectModalCancelClicked}>Cancel</SecondaryButton>
            </div>
          </div>
        </Fragment>
      </PopUpModal>
    </div>
  );
};

export default MemberClubTransferApproval;